var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute","inset":"0px"}},[_c('div',{staticStyle:{"position":"relative","max-height":"100%","max-width":"100%","width":"100%","height":"100%"}},[_c('div',{staticClass:"fullFilled"},[_c('ProjectBudgetInfo',{staticClass:"fullFilled"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }